export default "__VITE_ASSET__C9TV1NNJ__"